PJQ.views.primeContracts.ChangeOrdersList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'prime-contract-change-orders-list'),
        changeOrderId: null
    },
    events: {
        'click .btn-settings': 'editSettings',
        'click .btn-add-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-delete-change-order': 'deleteChangeOrderClicked',
        'click .btn-export': 'exportChangeOrderList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.ChangeOrders(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.customFields = await this.options.project.fetchPrimeContractChangeOrderCustomFields();
        this.userSettings = await PJQ.app.session.fetchPrimeContractChangeOrderUserSettings();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderView();

        PJQ.app.session.project.off('contractCOChanged');
        PJQ.app.session.project.on('contractCOChanged', function (changeOrder) {
            this.collection.add(changeOrder);
            this.render();
        }, this);

        if (this.options.changeOrderId > 0) {
            let initChangeOrder = this.collection.get(this.options.changeOrderId);
            if (initChangeOrder != null) {
                this.viewChangeOrder(initChangeOrder);
                this.options.changeOrderId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.primeContracts.ChangeOrderDataTable({
            el: this.$('.change-orders-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.primeContracts.view.CHANGE_ORDERS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    exportChangeOrderList: function () {
        let parameters = [
            {
                parameter: 'timeZoneOffset',
                value: new Date().getTimezoneOffset()
            }
        ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'primecontractchangeorders'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    newChangeOrder: function (e) {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        let isNew = changeOrder == null
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            model: changeOrder,
            onSave: _.bind(function (changeOrder) {
                if (isNew) {
                    this.collection.add(changeOrder);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (changeOrder) {
                this.collection.remove(changeOrder);
                this.renderView();
            }, this)
        });
    },
    deleteChangeOrderClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteChangeOrder(row);
    },
    deleteChangeOrder: function (row) {
        if (row != null) {
            let changeOrder = row.data();
            if (changeOrder != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Change Order",
                    body: "Are you sure you want to delete this Change Order?",
                    onDelete: _.bind(function () {
                        changeOrder.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(changeOrder);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    editSettings: function () {
        new PJQ.views.primeContracts.ChangeOrderSettingsModal({
            changeOrdersView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    }
});

PJQ.views.primeContracts.ModalViewChangeOrders = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-view-change-orders'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.primeContracts.ChangeOrdersList({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});

PJQ.views.primeContracts.SelectChangeOrdersModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-select-change-orders'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-change-order": "selectChangeOrder",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.selectedCids = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.primeContracts.ChangeOrders(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        let data;
        if (this.options.filterStatuses != null) {
            data = _.filter(this.collection.models, function (model) {
                let statusId = model.get('statusId');

                if (_.isArray(this.options.filterStatuses)) {
                    return _.includes(this.options.filterStatuses, statusId);
                } else if (_.isNumber(this.options.filterStatuses)) {
                    return this.options.filterStatuses === statusId;
                }

                return false;

            }, this);
        } else {
            data = this.collection.models;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-orders-table'),
            data: data,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "id",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let selected = this.selectedCids.indexOf(row.cid) !== -1
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (selected ? 'checked' : '') + ' class="select-change-order"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectChangeOrder: function (e) {
        let $target = $(e.currentTarget),
            changeOrder = this.dataTable.getRow($target.closest('tr')).data(),
            isSelected = $target.prop('checked');
        if (this.options.isSingleChoice) {
            this.selectedCids = isSelected ? [changeOrder.cid] : [];
        } else {
            if (isSelected) {
                this.selectedCids.push(changeOrder.cid);
            } else {
                this.selectedCids = _.without(this.selectedCids, changeOrder.cid);
            }
        }

        if (typeof this.options.onSelected === 'function') {
            this.options.onSelected(this.selectedPrimeContract);
        }

        this.dataTable.refresh();

        this.$('.btn-save').prop('disabled', _.size(this.selectedCids) === 0);
    },
    getSelected: function () {
        if (this.options.isSingleChoice) {
            if (_.size(this.selectedCids) === 0) {
                return null;
            }
            return this.collection.get(this.selectedCids[0]);
        }

        return _.filter(this.collection.models, (model) => {
            return this.selectedCids.indexOf(model.cid) !== -1;
        });
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.getSelected());
            this.removeModal();
        }
    }
});